var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTvshow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "UI_icon_video_recorder_light",
    "data-name": "UI icon/video_recorder/light",
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 14,
    viewBox: "0 0 20 14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Union",
    d: "M12,14H3a3,3,0,0,1-3-3V3A3,3,0,0,1,3,0h9a3,3,0,0,1,3,3v.572l1.837-1.312a1.98,1.98,0,0,1,1.155-.376,2.01,2.01,0,0,1,2.007,2v6.227a2.01,2.01,0,0,1-2.007,2,1.98,1.98,0,0,1-1.155-.376L15,10.428V11A3,3,0,0,1,12,14ZM3,2A1,1,0,0,0,2,3v8a1,1,0,0,0,1,1h9a1,1,0,0,0,1-1V3a1,1,0,0,0-1-1ZM18,3.886,15,6.029V7.97l3,2.143Z",
    transform: "translate(0 0)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTvshow);
export default __webpack_public_path__ + "static/media/tvshow.613b592763d3d6f156ffed17b872b1b5.svg";
export { ForwardRef as ReactComponent };